import 'bootstrap/dist/css/bootstrap.min.css';
import React, { useEffect, useMemo, useCallback, useRef, useState } from 'react';
import html2PDF from 'jspdf-html2canvas';

//styles
import {
  Accordion,
  Card,
  Col,
  Container,
  Dropdown,
  DropdownButton,
  Form,
  InputGroup,
  Overlay,
  Popover,
  useAccordionButton,
} from 'react-bootstrap';
import { CheckCircle, Eye, InfoCircleFill, Percent, Printer, Trash, Receipt } from 'react-bootstrap-icons';
import { useReactToPrint } from 'react-to-print';
import Button from '../../components/Button';
import { formatMoney, getFromSessionStorage } from '../../constants/functions';
import { useUserContext } from '../../context/UserContext';
import { Bid, calculateOffers, getOffers, saveOffers, OffersRes } from '../../services/bidOffer';
import { AlertContent } from '../BilletSend/styles';
import { PageTitleContainer, Title } from '../ChangeAddress/styles';
import { ButtonsContainer } from '../GroupsAvailability/styles';
import { useStylization } from '../../hooks/useStylization';
import {
  AllQuotasOffer,
  BidEditButton,
  CardHead,
  Collumn,
  Forms,
  InputLine,
  Offer,
  OfferForm,
  Row,
  Tag2,
  Title2,
  PrintContainer,
  LogoSidenav,
  LogoImage,
  TextCenter,
  Separator,
  ContainerPdf,
  Bluetext,
} from './styles';
import ModalInfo from '../../components/ModalInfo';
import { OfferInput, OfferInputType } from '../../components/Form/OfferInput';
import api from '../../services/api';
import { getCurrentAccountStatementInfo } from '../../services/currentAccoutStatement';

const lanceTypeLookupTable: { [key: string]: OfferInputType } = {
  '1': 'integer',
  '2': 'percent',
  '3': 'money',
};

// Só compara com a oferta na mesma unidade (% ou parcelas); em R$ (tipo '3') quem converte
// é o backend, então o ajuste fica para o handleCalculate
const getLimiteEfetivoEmbutido = (lanceTipoLance: string, maxLanceEmbutido: number, lanceOferta: number) => {
  if (!Number.isFinite(maxLanceEmbutido)) return 0;
  if (lanceTipoLance === '3' || !Number.isFinite(lanceOferta)) return maxLanceEmbutido;

  return Math.min(maxLanceEmbutido, lanceOferta);
};

// Mesma condição que bloqueia a oferta individual: modalidade sem faixa de escolha (mínimo igual ao
// máximo, como o lance fixo) ou lance quitação (forma '15'). Nesses casos a oferta é definida pela
// regra de apuração, então não pode ser feita em valor (R$), apenas em percentual ou parcelas
const isRegraLanceFixo = (regra?: Regra) => {
  if (!regra || regra.forma === '99' || regra.forma === '00') return false;
  if (regra.forma === '15') return true;

  const minimo = Number(regra.minimo?.trim().replace(',', '.'));
  const maximo = Number(regra.maximo?.trim().replace(',', '.'));

  if (!Number.isFinite(minimo) || !Number.isFinite(maximo)) return false;

  return maximo === 0 || minimo === maximo;
};

// @ts-ignore
function CustomToggle({ children, eventKey, onClick, hierarchy = 'primary', disabled = false }) {
  const decoratedOnClick = useAccordionButton(eventKey, onClick);

  return (
    <Button
      type="button"
      onClick={(e: any) => {
        decoratedOnClick(e);
      }}
      disabled={disabled}
      hierarchy={hierarchy}
    >
      {children}
    </Button>
  );
}

interface BidOption {
  lanceFormaContemplacaoQta: string;
  lanceCodRegraApuracao: string;
  lanceGrupo: string;
  lanceCota: string;
  lanceTipoLance: string;
  lanceOferta: string;
  embutido: boolean;
  percEmbutido: string;
  selectedRule: any;
  lanceQtdeMaximoGrupo: string;
  lanceQtdeMinimoGrupo: string;
  lanceValorMaximoGrupo: string;
  lanceValorMinimoGrupo: string;
  lanceEmbutidoLiberarConso: string;
}

export interface Regra {
  codigo: string;
  prioridade: string;
  forma: string;
  descricao: string;
  minimo: string;
  maximo: string;
  quantidade: string;
  limite: string;
  maxLanceEmbutido: string;
  tipoCalcLanceEmbutido: string;
  notMapped: string;
}

export type ConsolidadaResponse = {
  contempladas: Array<{
    grupo: string;
    cota: string;
    data: string;
    valorParcela: string;
    saldoDevedor: string;
    percentualDevedor: string;
    saldoPago: string;
    percentualPago: string;
    credito: string;
  }>;
  naoContempladas: Array<{
    grupo: string;
    cota: string;
    data: string;
    valorParcela: string;
    saldoDevedor: string;
    percentualDevedor: string;
    saldoPago: string;
    percentualPago: string;
    credito: string;
  }>;
  total: {
    credito: string;
    totalCotas: string;
    saldoPago: string;
    saldoDevedor: string;
    valorParcela: string;
  };
};

const BidOffer = () => {
  const { userData, group, quota } = useUserContext();

  const [emails, setEmails] = useState([{ type: '', value: '' }]);

  const [extract, setExtract] = useState<any>();

  const [name, setName] = useState([{ type: '', value: '' }]);

  const [showAlert] = useState<boolean>();

  const [view, setView] = useState<'all' | 'form'>('all');

  const [formStep, setFormStep] = useState(0);

  const [offersInitial, setOffersInitial] = useState<Bid[]>();

  const [isEmbeddedBidChecked, setIsEmbeddedBidChecked] = useState(false);
  const [typeEmbeddedBid, setTypeEmbeddedBid] = useState<'percent' | 'money' | 'integer'>('percent');

  const [gruposCotas, setGruposCotas] = useState<any[]>();
  const [contemplation, setContemplation] = useState<Regra[]>();
  const [offersForm, setOffersForm] = useState<BidOption[]>([]);
  const [errorsForm, setErrorsForm] = useState<string[]>([]);
  const [allFilters, setAllFilters] = useState('0');
  const [allOffersRule, setAllOffersRule] = useState('');
  const [percEmbutido, setPercEmbutido] = useState<string[]>([]);
  const [globalLanceValue, setGlobalLanceValue] = useState('');
  const [globalEmbutidoValue, setGlobalEmbutidoValue] = useState('');

  const [revisionOffers, setRevisionOffers] = useState<any[]>([]);

  const [emissionTimestamp, setEmissionTimestamp] = useState('');
  const [emissionDate, setEmissionDate] = useState('');
  const [emissionTime, setEmissionTime] = useState('');

  const { stylization } = useStylization();

  const [finalOffers, setFinalOffers] = useState<any[]>([]);

  const allLanceMaxEmbutido000 = useMemo(() => {
    if (!offersInitial || offersInitial.length === 0) {
      return false;
    }

    // Lógica para verificar se existe percentual e parcelas no mesmo conjunto de ofertas caso sim não permitir lance embutido
    const tipos = new Set(offersInitial.map((o) => o.lanceTipoLance));
    if (tipos.has('1') && tipos.has('2')) {
      return true;
    }

    if (offersInitial.some((item) => item.lanceEmbutidoLiberarConso === 'N')) {
      return true;
    }

    return offersInitial.every((offer) => offer.lanceMaxEmbutido.trim() === '000');
  }, [offersInitial]);

  useEffect(() => {
    if (!userData) return;

    const cpfCnpj = getFromSessionStorage('cpfCnpj');

    api
      .get<any, ConsolidadaResponse>('/consorciado/consolidada', {
        params: { cpfCnpj },
      })
      .then((data) => {
        const naoContempladas = data.naoContempladas;

        setGruposCotas(
          naoContempladas.map((n) => ({
            cota: n.cota,
            grupo: n.grupo,
          }))
        );

        // Adicionando retorno dos emails do usuário
        setEmails(
          userData?.emails.map((email) => {
            return {
              type: '',
              value: email.endereco,
            };
          }) as []
        );

        setName([
          {
            type: '',
            value: userData?.nome || '',
          },
        ]);
      });
  }, [userData, group, quota]);

  useEffect(() => {
    if (!group || !quota) return;

    const func = async () => {
      try {
        const res1 = await getCurrentAccountStatementInfo(group, quota);
        setExtract(res1);
      } catch (e) {
        console.log(e);
      }
    };
    func();
  }, [group, quota]);

  const searchOffers = useCallback(async () => {
    const { res, success } = await getOffers(gruposCotas as any[]);

    if (!success) {
      // setMessage(res.err['1'] ?? 'Ocorreu um erro inesperado!');
      // handleShow();
      return;
    }

    setOffersInitial(res.lances);

    return res;
  }, [gruposCotas]);

  useEffect(() => {
    const func = async () => {
      try {
        if (!gruposCotas) return;
        const res = await searchOffers();
        if (!res) return;
        setOffersForm(
          res.lances.map(
            (lance: any) =>
              ({
                lanceGrupo: lance.lanceGrupo,
                lanceCota: lance.lanceCota,
                lanceTipoLance: lance.lanceTipoLance,
                lanceOferta: lance.lanceOferta,
                lanceCodRegraApuracao: lance.lanceCodRegraApuracao,
                lanceQtdeMaximoGrupo: lance.lanceQtdeMaximoGrupo,
                lanceQtdeMinimoGrupo: lance.lanceQtdeMinimoGrupo,
                lanceValorMaximoGrupo: lance.lanceValorMaximoGrupo,
                lanceValorMinimoGrupo: lance.lanceValorMinimoGrupo,
                selectedRule: {
                  codigo: '1',
                  prioridade: '1',
                  forma: '1',
                },
                lanceEmbutidoLiberarConso: lance.lanceEmbutidoLiberarConso,
              } as BidOption)
          )
        );
        setContemplation(res.regras);
      } catch (e) {
        console.log(e);
      }
    };
    func();
  }, [gruposCotas, searchOffers]);

  const [show, setShow] = useState(false);
  const [target, setTarget] = useState(null);
  const [isNew, setIsNew] = useState(false);
  const ref = useRef(null);
  const printRef = useRef(null);

  const handleTooltip = (event: any) => {
    setShow(!show);
    setTarget(event.target);
  };

  const updateErrors = (field: string, error: boolean) => {
    if (error) {
      setErrorsForm([...errorsForm.filter((err) => err !== field), field]);
      return;
    }

    setErrorsForm(errorsForm.filter((err) => err !== field));
  };

  const hasError = (field: string) => {
    return errorsForm.some((error) => error === field);
  };

  function getNumericValue(text?: string | number) {
    if (text === undefined || text === null) return NaN;
    const s = String(text)
      .normalize('NFKC') // normaliza espaços/acentos “estranhos”
      .replace(/[^\d,.\-]+/g, '') // remove letras (ex.: "Parcelas", "Porcento")
      .replace(/\.(?=\d{3}(\D|$))/g, '') // remove milhar: 12.345 -> 12345
      .replace(',', '.'); // vírgula -> ponto

    return s === '' || s === '-' ? NaN : Number(s);
  }

  function hasParcelas(text?: unknown) {
    return /\bparcelas?\b/i.test(String(text ?? ''));
  }

  const handleCalculate = async () => {
    try {
      let _offers = [...offersForm];
      _offers = _offers.filter((offer, index) => {
        if (!offersInitial) return false;
        // if (['0'].includes(offer.lanceOferta) && offersInitial[index].lanceOferta === ' ') {
        //
        // }
        return !(['0'].includes(offer.lanceOferta) && offersInitial[index].lanceOferta === ' ');
        // return offer.lanceOferta && offer.lanceOferta != '0' && offer.lanceTipoLance;
      });

      // Calcula para verificar se há lances em espécie negativos
      const res = await calculateOffers(_offers);
      if (res.err) {
        // handleShow();
        // setMessage(res.err['1']);
        setView('all');
        setTimeout(() => {
          setView('form');
        }, 10);
        return;
      }

      // Verifica se algum lance embutido ficou acima do lance ofertado
      let needsRecalculation = false;
      const adjustedOffers = _offers.map((offer, index) => {
        const revisionOffer = res[index];
        if (!revisionOffer) return offer;

        // Embutido escolhido pelo consorciado ou aplicado pela administradora
        const initialOffer = offersInitial?.find(
          (lance) => lance.lanceGrupo === offer.lanceGrupo && lance.lanceCota === offer.lanceCota
        );
        const temEmbutido = offer.embutido || initialOffer?.lanceEmbutidoAplicar === 'S';

        if (!temEmbutido) return offer;

        // O cálculo devolve oferta e embutido na mesma unidade, mesmo se ofertado em R$
        const ofertaCalculada = String(revisionOffer['lanceOfertado'] ?? '');
        const isParcelas = hasParcelas(ofertaCalculada);

        // Sem a unidade o campo traz uma mensagem de erro
        if (!isParcelas && !/porcento/i.test(ofertaCalculada)) return offer;

        const lanceOfertado = getNumericValue(ofertaCalculada);
        const percentualEmbutido = getNumericValue(revisionOffer['lanceMsgTextoEmbutido']);

        if (Number.isNaN(lanceOfertado) || Number.isNaN(percentualEmbutido)) return offer;

        // O lance embutido deve ser limitado ao lance ofertado
        if (percentualEmbutido <= lanceOfertado) return offer;

        needsRecalculation = true;

        return {
          ...offer,
          embutido: true,
          percEmbutido: isParcelas ? lanceOfertado.toString() : lanceOfertado.toFixed(4),
        };
      });

      // Faz nova chamada ao backend com valores ajustados
      if (needsRecalculation) {
        const recalculatedRes = await calculateOffers(adjustedOffers);
        if (recalculatedRes.err) {
          setView('all');
          setTimeout(() => {
            setView('form');
          }, 10);
          return;
        }
        setRevisionOffers(recalculatedRes);
        // Atualiza o offersForm com os valores ajustados
        setOffersForm((currentOffers) => {
          return currentOffers.map((offer) => {
            const adjusted = adjustedOffers.find(
              (adj) => adj.lanceGrupo === offer.lanceGrupo && adj.lanceCota === offer.lanceCota
            );
            return adjusted || offer;
          });
        });
      } else {
        setRevisionOffers(res);
      }
    } catch (e) {
      console.log(e);
    }
    setFormStep(1);
  };
  const handleSave = async () => {
    try {
      const now = new Date();
      const options: Intl.DateTimeFormatOptions = {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        hour12: false, // 24-hour format
      };
      const formattedDate = now.toLocaleString('pt-BR', options).replace(',', ' -');
      setEmissionTimestamp(formattedDate);

      // Extract date and time separately
      const [date, time] = formattedDate.split(' - ');
      setEmissionDate(date);
      setEmissionTime(time);

      let _offers = [...offersForm];
      _offers = _offers.filter((offer) => {
        return revisionOffers
          .map((rev) => rev.lanceCota + '' + rev.lanceGrupo)
          .includes(offer.lanceCota + '' + offer.lanceGrupo);
      });

      const percentuaisEmbutidos = _offers.map((offer) => offer.percEmbutido);
      setPercEmbutido(percentuaisEmbutidos);

      const res = await saveOffers(_offers);
      setFinalOffers(res);
    } catch (e) {
      console.log(e);
    }
    setFormStep(2);
  };
  const handleNew = () => {
    if (!offersInitial || !contemplation) return;
    let _offers = [
      ...offersInitial.map(
        (lance) =>
          ({
            lanceGrupo: lance.lanceGrupo,
            lanceCota: lance.lanceCota,
            lanceTipoLance: lance.lanceTipoLance,
            lanceOferta: lance.lanceOferta,
            lanceQtdeMaximoGrupo: lance.lanceQtdeMaximoGrupo,
            lanceQtdeMinimoGrupo: lance.lanceQtdeMinimoGrupo,
            lanceCodRegraApuracao: lance.lanceCodRegraApuracao,
            lanceValorMaximoGrupo: lance.lanceValorMaximoGrupo,
            lanceValorMinimoGrupo: lance.lanceValorMinimoGrupo,
            lanceEmbutidoLiberarConso: lance.lanceEmbutidoLiberarConso,
            selectedRule: contemplation.find((cont) => cont.forma === '99'),
          } as BidOption)
      ),
    ];
    _offers = _offers?.filter((offer) => offer.lanceOferta === ' ') as any;

    for (let i = 0; i < _offers.length; i++) {
      _offers[i].lanceOferta = '0';
      _offers[i].selectedRule = contemplation?.find((cont) => cont.forma === '99');
    }

    setIsNew(true);
    setFormStep(0);
    setOffersForm(_offers);
    setView('form');
  };
  const handleEdit = () => {
    setIsNew(false);
    if (!offersInitial || !contemplation) return;
    const _offers = [
      ...offersInitial.map(
        (lance) =>
          ({
            lanceGrupo: lance.lanceGrupo,
            lanceCota: lance.lanceCota,
            lanceTipoLance: lance.lanceTipoLance,
            lanceOferta: lance.lanceOferta,
            lanceQtdeMaximoGrupo: lance.lanceQtdeMaximoGrupo,
            lanceQtdeMinimoGrupo: lance.lanceQtdeMinimoGrupo,
            lanceCodRegraApuracao: lance.lanceCodRegraApuracao,
            lanceValorMaximoGrupo: lance.lanceValorMaximoGrupo,
            lanceValorMinimoGrupo: lance.lanceValorMinimoGrupo,
            lanceEmbutidoLiberarConso: lance.lanceEmbutidoLiberarConso,
            selectedRule: contemplation.find((cont) => cont.forma === '11'),
          } as BidOption)
      ),
    ];

    for (let i = 0; i < offersInitial.length; i++) {
      if (offersInitial[i].lanceFormaContemplacaoQta < '11') {
        offersInitial[i].lanceFormaContemplacaoQta = '99';
      }
      _offers[i].lanceOferta = Number(offersInitial[i].lanceOferta.replace(',', '.')).toString();
      // _offers[i].lanceTipoLance = '2';
      _offers[i].selectedRule = contemplation?.find(
        (cont) => cont.forma === offersInitial[i].lanceFormaContemplacaoQta
      );
    }

    setOffersForm(_offers);
    setView('form');
  };

  const handleChangeTipoLance = (index: number, lanceTipoLance: string) => {
    const _offers = [...offersForm];
    _offers[index].lanceTipoLance = lanceTipoLance;
    setOffersForm(_offers);
  };

  const rulesForAllCases = useMemo(() => {
    if (!contemplation) return [];

    const grupos = new Map<string, Regra[]>();

    // Agrupar os itens pelo campo 'codigo'
    for (const item of contemplation.filter((c) => c.forma !== '00')) {
      if (!grupos.has(item.codigo)) {
        grupos.set(item.codigo, []);
      }
      grupos.get(item.codigo)?.push(item);
    }

    let resultado: string[] = [];

    for (const grupo of grupos.values()) {
      const decricoes = grupo.map((item) => item.descricao);
      if (resultado.length === 0) {
        resultado = decricoes;
      } else {
        resultado = resultado.filter((descricao) => decricoes.includes(descricao));
      }
    }
    return resultado;
  }, [contemplation]);

  // Mantém a modalidade exibida na caixa "Lance para todas as cotas" alinhada com a primeira opção
  useEffect(() => {
    setAllOffersRule((state) => state || rulesForAllCases[0] || '');
  }, [rulesForAllCases]);

  function handleChangeAllOffersRule(ruleDescription: string) {
    setAllOffersRule(ruleDescription);

    if (!ruleDescription || !contemplation || !offersInitial) return;

    setOffersForm((state) =>
      state.map((offer, index) => {
        const selectedRule = contemplation.find(
          (c) => c.descricao === ruleDescription && c.codigo === offer.lanceCodRegraApuracao
        );

        if (!selectedRule) return offer;

        const isLanceLivre = selectedRule.descricao.trim() === 'Lance Livre';
        // Lance Quitação (forma '15') também é limitado pelo percentual máximo do grupo, não pelo maximo genérico da regra
        const usaLimiteDoGrupo = isLanceLivre || selectedRule.forma === '15';
        const lanceLivreValue = offer.lanceQtdeMaximoGrupo.trim().replace(',', '.');

        const lanceOferta = usaLimiteDoGrupo
          ? lanceLivreValue // Use o percentual máximo do grupo para Lance Livre e Lance Quitação
          : Number(selectedRule.maximo ?? 0).toString(); // Default to maximo for other rules

        // Embutido aplicado pela administradora, sem exibir a opção ao consorciado
        const initialOffer = offersInitial.find(
          (lance) => lance.lanceGrupo === offer.lanceGrupo && lance.lanceCota === offer.lanceCota
        );
        const embutido = initialOffer?.lanceEmbutidoAplicar === 'S' || offer.embutido;

        // Enquanto o tipo de oferta não for escolhido, mantém o tipo de lance da própria cota
        const lanceTipoLance = allFilters !== '0' ? allFilters : offer.lanceTipoLance;

        // Calcular percEmbutido limitado ao menor valor entre maxLanceEmbutido e lanceOferta
        let percEmbutido = '';
        if (embutido && selectedRule.maxLanceEmbutido) {
          const effectiveLimit = getLimiteEfetivoEmbutido(
            lanceTipoLance,
            Number(selectedRule.maxLanceEmbutido),
            Number(lanceOferta)
          );
          percEmbutido = effectiveLimit.toString();
        }

        return {
          ...offer,
          lanceOferta,
          lanceTipoLance,
          embutido,
          selectedRule,
          percEmbutido,
        };
      })
    );
  }

  const validateAllOffersLimits = () => {
    if (!offersForm || !offersInitial) return false;

    let hasError = false;

    offersForm.forEach((offer, index) => {
      const val = offer.lanceOferta?.trim();

      if (!val || val === '0') {
        return;
      }

      const parsedValue = val.replace(',', '.');
      const parsedLanceOferta = parseFloat(parsedValue) || 0;

      const maxPermitido = Number(offer.selectedRule?.maximo);
      const minPermitido = Number(offer.selectedRule?.minimo);

      const valDigitado = Number(parsedValue);

      if (offer.lanceTipoLance === '1') {
        const maxGrupo = Number(offersInitial[index].lanceQtdeMaximoGrupo.trim().replace(',', '.'));
        const minGrupo = Number(offersInitial[index].lanceQtdeMinimoGrupo.trim().replace(',', '.'));

        const invalido = valDigitado < minGrupo || valDigitado > maxGrupo;

        if (invalido) hasError = true;
      } else if (offer.lanceTipoLance === '3') {
        const maxGrupo = Number(offersInitial[index].lanceValorMaximoGrupo.trim().replace(',', '.')) / 100;
        const minGrupo = Number(offersInitial[index].lanceValorMinimoGrupo.trim().replace(',', '.')) / 100;

        const invalido = valDigitado < minGrupo || valDigitado > maxGrupo;

        if (invalido) hasError = true;
      } else {
        const isAcimaouAbaixoDoPermitido = parsedLanceOferta > maxPermitido || parsedLanceOferta < minPermitido;

        if (isAcimaouAbaixoDoPermitido) hasError = true;
      }
    });

    return !hasError;
  };

  const allBidsHaveRuleSelected = offersForm.every((offer) => {
    const temValor = offer.lanceOferta && offer.lanceOferta.trim() !== '' && offer.lanceOferta.trim() !== '0';

    // Se a cota não tem valor, não é obrigatório escolher o tipo
    if (!temValor) return true;

    // Se tem valor, exige que o tipo de lance esteja escolhido
    return offer.selectedRule && offer.selectedRule.forma !== '99';
  });

  const updatePercEmbutido = (index: number, value: string | undefined) => {
    const _offers = [...offersForm];
    const selectedRule = _offers[index].selectedRule;
    const lanceMaximoEmbutido = selectedRule ? Number(selectedRule.maxLanceEmbutido) : 0;
    const parsedLanceOferta = parseFloat(value ? value.replace(',', '.') : '0') || 0;

    // Only update percEmbutido if embutido is true
    if (_offers[index].embutido) {
      // O limite efetivo é o menor valor entre maxLanceEmbutido e o valor do lance ofertado
      const effectiveLimit = getLimiteEfetivoEmbutido(
        _offers[index].lanceTipoLance,
        lanceMaximoEmbutido,
        parsedLanceOferta
      );

      let finalPercEmbutido: string;

      switch (_offers[index].lanceTipoLance) {
        case '1':
          finalPercEmbutido = effectiveLimit.toString();
          break;

        case '2':
          finalPercEmbutido = effectiveLimit.toFixed(4);
          break;

        case '3':
          finalPercEmbutido = effectiveLimit.toFixed(4);
          break;

        default:
          finalPercEmbutido = effectiveLimit.toFixed(4);
          break;
      }

      _offers[index] = {
        ..._offers[index],
        lanceOferta: value || '0',
        percEmbutido: finalPercEmbutido,
      };
    } else {
      _offers[index] = {
        ..._offers[index],
        lanceOferta: value || '0',
      };
    }

    setOffersForm(_offers);
  };

  const updatePercEmbutidoForAll = (value: string | undefined) => {
    const parsedLanceOferta = parseFloat(value ? value.replace(',', '.') : '0') || 0;

    setOffersForm((state) =>
      state.map((offer) => {
        const selectedRule = offer.selectedRule;
        const lanceMaximoEmbutido = selectedRule ? Number(selectedRule.maxLanceEmbutido) : 0;

        // Somente limite percEmbutido global quando embutido for verdadeiro
        let newPercEmbutido = offer.percEmbutido;

        if (offer.embutido) {
          // O limite efetivo é o menor valor entre maxLanceEmbutido e o lance ofertado
          const effectiveLimit = getLimiteEfetivoEmbutido(offer.lanceTipoLance, lanceMaximoEmbutido, parsedLanceOferta);

          switch (offer.lanceTipoLance) {
            case '1':
              newPercEmbutido = effectiveLimit.toString();
              break;

            case '2':
              newPercEmbutido = effectiveLimit.toFixed(4);
              break;

            case '3':
              newPercEmbutido = effectiveLimit.toFixed(4);
              break;

            default:
              newPercEmbutido = effectiveLimit.toFixed(4);
              break;
          }
        }

        setGlobalEmbutidoValue(newPercEmbutido);

        return {
          ...offer,
          // Não limite lanceOferta diretamente aqui, delegue ao controle individual se necessário
          lanceOferta: value || '', // Deixe o lanceOferta no valor recebido
          percEmbutido: newPercEmbutido,
        };
      })
    );
  };

  const maxClampedValue = offersForm.reduce((minValue, offer) => {
    const maxLance = offer.selectedRule?.maxLanceEmbutido || 0;
    return Math.min(minValue, maxLance);
  }, parseFloat(globalLanceValue.replace(',', '.') || '0'));

  useEffect(() => {
    if (isEmbeddedBidChecked) {
      setTypeEmbeddedBid(lanceTypeLookupTable[allFilters]);
    }
  }, [allFilters, isEmbeddedBidChecked]);

  // Verifica se a modalidade escolhida para todas as cotas é de lance fixo, considerando apenas as
  // regras de apuração das cotas em edição — é o que define se a oferta em valor (R$) fica bloqueada
  const isLanceFixoParaTodasCotas = useMemo(() => {
    if (!contemplation || !allOffersRule || offersForm.length === 0) return false;

    const codigosEmUso = new Set(offersForm.map((offer) => offer.lanceCodRegraApuracao));

    const regrasSelecionadas = contemplation.filter(
      (regra) => regra.descricao.trim() === allOffersRule.trim() && codigosEmUso.has(regra.codigo)
    );

    if (regrasSelecionadas.length === 0) return false;

    return regrasSelecionadas.some(isRegraLanceFixo);
  }, [contemplation, allOffersRule, offersForm]);

  const allFilterOptions = useMemo(() => {
    if (!offersInitial) return [];

    const options = [...new Set(offersInitial.map((item) => item.lanceTipoLance))];

    // só adiciona "3" (R$) se tiver lanceOfertaEmValor = "S" e a modalidade não for de lance fixo,
    // que só aceita oferta em percentual ou parcelas, conforme a regra de apuração
    if (!isLanceFixoParaTodasCotas && offersInitial.some((item) => item.lanceOfertaEmValor === 'S')) {
      options.push('3');
    }

    if (options.length > 2) return [options[0], '3'];

    return options;
  }, [offersInitial, isLanceFixoParaTodasCotas]);

  // Ao trocar para uma modalidade de lance fixo com a oferta já em R$, volta para a unidade da cota
  useEffect(() => {
    if (allFilters !== '3' || allFilterOptions.includes('3')) return;

    setAllFilters(allFilterOptions[0] ?? '0');
  }, [allFilters, allFilterOptions]);

  useEffect(() => {
    if (!offersForm || !allFilters || allFilters === '0') return;

    let _offers = [...offersForm];
    _offers = _offers.map((offer) => {
      return {
        ...offer,
        lanceTipoLance: allFilters,
      };
    });
    setOffersForm(_offers);
  }, [allFilters]);

  const handlePrint = useReactToPrint({
    content: () => printRef?.current,
  });

  const handleInvoice = () => {
    const input = document.getElementById('printRef') as HTMLElement;
    html2PDF(input, {
      jsPDF: {
        format: 'a4',
        orientation: 'portrait',
      },
      imageType: 'image/jpeg',
      imageQuality: 0.2,
      output: 'invoice.pdf',
    });
  };

  const renderFilter = (data: string) => {
    if (data === '1') {
      return 'Parcelas';
    }
    if (data === '2') {
      return '%';
    }
    if (data === '3') {
      return 'R$';
    }
  };
  // const [message, setMessage] = useState('');
  // const [showModal, setShowModal] = useState(false);
  // const handleClose = () => setShowModal(false);
  // const handleShow = () => setShowModal(true);

  const pageContent = () => {
    return (
      <>
        <PageTitleContainer>
          {/* <ModalInfo message={message} show={showModal} handleClose={handleClose} header={'Alerta'}></ModalInfo> */}
          <Title>Oferta de Lance</Title>
          <ButtonsContainer>
            {view === 'all' ? (
              <>
                {offersInitial && !offersInitial.every((offer) => offer.lanceOferta !== ' ') && (
                  <CustomToggle eventKey={'0'} onClick={() => handleNew()}>
                    Novo Lance
                  </CustomToggle>
                )}

                <BidEditButton hierarchy={'secondary'} onClick={() => handleEdit()}>
                  Editar Lance
                </BidEditButton>
              </>
            ) : (
              <>
                <BidEditButton
                  hierarchy={'secondary'}
                  onClick={() => {
                    searchOffers();
                    setView('all');
                    setIsNew(false);
                  }}
                >
                  Ver todos os Lances
                </BidEditButton>
              </>
            )}
          </ButtonsContainer>
        </PageTitleContainer>
        {showAlert && (
          <AlertContent>
            <CheckCircle size={22} />
            Alterações feita com sucesso!
          </AlertContent>
        )}
        {view === 'form' ? (
          <Forms>
            <Accordion defaultActiveKey="0">
              <Card>
                <CardHead className={formStep >= 1 ? 'finished' : formStep === 0 ? 'active' : ''}>
                  Criar novo Lance
                </CardHead>

                <Accordion.Collapse eventKey="0">
                  <Card.Body>
                    <div className={'row'}>
                      <div className="col-lg-5 col-xl-3">
                        <AllQuotasOffer>
                          <h3>Lance para todas as cotas</h3>

                          <Form.Select
                            aria-label="Default select example"
                            value={allOffersRule}
                            onChange={(e) => {
                              handleChangeAllOffersRule(e.target.value);
                            }}
                          >
                            {rulesForAllCases.map((ruleDescription) => (
                              <option key={ruleDescription} value={ruleDescription}>
                                {ruleDescription.trim()}{' '}
                              </option>
                            ))}
                          </Form.Select>
                          <Form.Select
                            aria-label="Default select example"
                            onChange={(e) => setAllFilters(e.target.value)}
                            hidden={allFilters !== '0'}
                          >
                            <option key={0} value={'0'}>
                              Selecione o tipo de oferta
                            </option>
                            {allFilterOptions.map((item) => (
                              <option key={item} value={item}>
                                {item === '2' ? '%' : item === '1' ? 'Parcelas' : 'R$'}
                              </option>
                            ))}
                          </Form.Select>
                          <InputGroup hidden={allFilters === '0'}>
                            <OfferInput
                              type={lanceTypeLookupTable[allFilters]}
                              // No lance fixo a oferta é definida pela regra de apuração, igual ao individual
                              disabled={isLanceFixoParaTodasCotas}
                              onValueChange={(val) => {
                                setGlobalLanceValue(val || '');
                                updatePercEmbutidoForAll(val);
                                setTypeEmbeddedBid(lanceTypeLookupTable[allFilters]);
                              }}
                            />
                            {/* <Form.Control
                              aria-label="Text input with dropdown button"
                              onChange={(e) => {

                            /> */}

                            <DropdownButton
                              variant="outline-secondary"
                              title={renderFilter(allFilters)}
                              id="input-group-dropdo6"
                              align="end"
                              disabled={isLanceFixoParaTodasCotas}
                            >
                              {allFilterOptions.map((item) => (
                                <Dropdown.Item key={item} onClick={() => setAllFilters(item)}>
                                  {item === '2' ? '%' : item === '1' ? 'Parcelas' : 'R$'}
                                </Dropdown.Item>
                              ))}
                            </DropdownButton>
                          </InputGroup>
                          <InputGroup style={{ alignItems: 'center' }}>
                            {!allLanceMaxEmbutido000 && (
                              <Form.Check
                                type="checkbox"
                                label="Lance embutido"
                                id="newEmbeddedBid"
                                onChange={(e) => {
                                  const isChecked = e.target.checked;
                                  setIsEmbeddedBidChecked(isChecked);

                                  setOffersForm((state) =>
                                    state.map((val, index) => {
                                      const selectedRule = val.selectedRule;
                                      setTypeEmbeddedBid(lanceTypeLookupTable[val.lanceTipoLance]);

                                      const lanceMaxEmbutido = selectedRule ? Number(selectedRule.maxLanceEmbutido) : 0;
                                      const currentLanceOferta = parseFloat(val.lanceOferta.replace(',', '.') || '0');

                                      if (
                                        Number(selectedRule?.lanceMaxEmbutido) === 0 &&
                                        val.lanceTipoLance === (offersInitial ?? [])[index].lanceTipoLance
                                      ) {
                                        return val;
                                      }

                                      // O limite efetivo é o menor entre maxLanceEmbutido e o lance ofertado
                                      const effectiveLimit = getLimiteEfetivoEmbutido(
                                        val.lanceTipoLance,
                                        lanceMaxEmbutido,
                                        currentLanceOferta
                                      );

                                      let finalVal: string;

                                      switch (typeEmbeddedBid) {
                                        case 'integer':
                                          finalVal = effectiveLimit.toString();
                                          break;

                                        case 'money':
                                          finalVal = effectiveLimit.toFixed(4);
                                          break;

                                        case 'percent':
                                          finalVal = effectiveLimit.toFixed(4);
                                          break;

                                        default:
                                          finalVal = effectiveLimit.toFixed(4);
                                          break;
                                      }

                                      const percEmbutido = isChecked ? finalVal : '';

                                      return {
                                        ...val,
                                        embutido: isChecked,
                                        percEmbutido,
                                      };
                                    })
                                  );
                                }}
                              />
                            )}
                            {isEmbeddedBidChecked && (
                              <OfferInput
                                style={{ borderRadius: '4px', marginLeft: '20px' }}
                                type={typeEmbeddedBid === 'money' ? 'percent' : typeEmbeddedBid}
                                value={
                                  isEmbeddedBidChecked
                                    ? typeEmbeddedBid == 'integer'
                                      ? globalEmbutidoValue.toString()
                                      : parseFloat(globalEmbutidoValue.replace(',', '.') || '0').toFixed(4)
                                    : parseFloat(globalLanceValue.replace(',', '.') || '0').toFixed(4)
                                }
                                onChange={(e) => {
                                  let newValue = e.target.value || '';
                                  newValue = newValue.replace(',', '.');

                                  const validNumber = parseFloat(newValue);
                                  const finalValue = !isNaN(validNumber) ? validNumber : 0;

                                  setOffersForm((state) => {
                                    return state.map((offer, index) => {
                                      const isDisabled =
                                        Number(offer.selectedRule?.maxLanceEmbutido) === 0 &&
                                        offer.lanceTipoLance === (offersInitial ?? [])[index]?.lanceTipoLance;

                                      const maxLimit = offersInitial
                                        ? Number(offersInitial[index].lanceMaxEmbutido.trim().replace(',', '.'))
                                        : 0;

                                      // O limite efetivo é o menor entre maxLimit e o valor do lance ofertado
                                      const lanceOfertaValue = Number(offer.lanceOferta.trim().replace(',', '.'));
                                      const effectiveLimit = getLimiteEfetivoEmbutido(
                                        offer.lanceTipoLance,
                                        maxLimit,
                                        lanceOfertaValue
                                      );

                                      const clampedValue = Math.min(finalValue, effectiveLimit);
                                      let clampedString: string;

                                      switch (offer.lanceTipoLance) {
                                        case '1':
                                          clampedString = clampedValue.toString();
                                          break;
                                        case '2':
                                          clampedString = clampedValue.toFixed(4);
                                          break;
                                        case '3':
                                          clampedString = clampedValue.toFixed(4);
                                          break;
                                        default:
                                          clampedString = clampedValue.toFixed(4);
                                          break;
                                      }

                                      setGlobalEmbutidoValue(clampedString);

                                      if (!isDisabled) {
                                        updateErrors(`percEmbutido${index}`, finalValue > effectiveLimit);
                                      }

                                      return {
                                        ...offer,
                                        percEmbutido: offer.embutido ? clampedString : offer.percEmbutido,
                                      };
                                    });
                                  });

                                  const newGlobalValue =
                                    typeEmbeddedBid !== 'integer'
                                      ? Math.min(
                                          finalValue,
                                          ...offersForm.map((offer) => offer.selectedRule?.maxLanceEmbutido || 0)
                                        ).toFixed(4)
                                      : Math.min(
                                          finalValue,
                                          ...offersForm.map((offer) => offer.selectedRule?.maxLanceEmbutido || 0)
                                        ).toString();
                                  setGlobalLanceValue(newGlobalValue);
                                }}
                              />
                            )}
                          </InputGroup>
                        </AllQuotasOffer>
                        <div className={'mt-4'}>
                          <CustomToggle
                            onClick={() => handleCalculate()}
                            eventKey={'1'}
                            disabled={
                              errorsForm.length > 0 ||
                              !offersForm.some((offer) => offer.lanceOferta && offer.selectedRule?.forma !== '99') ||
                              !allBidsHaveRuleSelected ||
                              !validateAllOffersLimits()
                            }
                          >
                            Confirmar
                          </CustomToggle>
                        </div>
                      </div>
                      <div className="mt-4 mt-lg-0 col-lg-7 col-xl-9">
                        <div className={'d-flex flex-column gap-3 w-100'}>
                          {offersForm?.map((offer, index) => {
                            const unidade = offer.lanceTipoLance === '1' ? 'pcl' : '%';

                            return (
                              <OfferForm key={`${offer.lanceGrupo}-${offer.lanceCota}`}>
                                <h3 className={'fw-bold'}>
                                  {offer.lanceGrupo} / {offer.lanceCota}
                                </h3>
                                <InputLine>
                                  <Collumn>
                                    <Form.Select
                                      aria-label="Default select example "
                                      value={offer?.selectedRule?.descricao.trim()}
                                      onChange={(e) => {
                                        const _offers = [...offersForm];

                                        let selectedRule = contemplation?.find(
                                          (rule) =>
                                            rule.codigo === offer.lanceCodRegraApuracao &&
                                            rule.descricao.trim() === e.target.value.trim()
                                        );

                                        const isLanceLivre = selectedRule?.descricao.trim() === 'Lance Livre';
                                        // Lance Quitação (forma '15') também é limitado pelo percentual máximo do grupo, não pelo maximo genérico da regra
                                        const usaLimiteDoGrupo = isLanceLivre || selectedRule?.forma === '15';
                                        const lanceLivreValue = offer.lanceQtdeMaximoGrupo.trim().replace(',', '.');

                                        let minimoValue: string;

                                        switch (offer.lanceTipoLance) {
                                          case '1':
                                            minimoValue = Number(
                                              offer.lanceQtdeMaximoGrupo.trim().replace(',', '.')
                                            ).toString();
                                            break;
                                          case '2':
                                            minimoValue = Number(selectedRule?.maximo ?? 0).toFixed(4);
                                            break;
                                          case '3':
                                            minimoValue = Number(selectedRule?.maximo ?? 0).toFixed(2);
                                            break;
                                          default:
                                            minimoValue = Number(selectedRule?.maximo ?? 0).toFixed(4);
                                            break;
                                        }

                                        const aplicarEmbutido =
                                          offersInitial && offersInitial[index]?.lanceEmbutidoAplicar === 'S';

                                        const lanceOfertaFinal = usaLimiteDoGrupo ? lanceLivreValue : minimoValue;

                                        // Calcular percEmbutido limitado ao menor valor entre maxLanceEmbutido e lanceOferta
                                        let percEmbutidoValue = '';
                                        if (
                                          (aplicarEmbutido || _offers[index].embutido) &&
                                          selectedRule?.maxLanceEmbutido
                                        ) {
                                          const effectiveLimit = getLimiteEfetivoEmbutido(
                                            _offers[index].lanceTipoLance,
                                            Number(selectedRule.maxLanceEmbutido),
                                            Number(lanceOfertaFinal)
                                          );
                                          percEmbutidoValue = effectiveLimit.toString();
                                        }

                                        _offers[index] = {
                                          ..._offers[index],
                                          lanceOferta: lanceOfertaFinal,
                                          embutido: aplicarEmbutido || _offers[index].embutido,
                                          selectedRule,
                                          percEmbutido: percEmbutidoValue,
                                        };

                                        setOffersForm(_offers);
                                      }}
                                    >
                                      {contemplation &&
                                        contemplation
                                          .filter(
                                            (cont) => cont.forma !== '00' && cont.codigo === offer.lanceCodRegraApuracao
                                          )
                                          .map((contemplationWay, index) => (
                                            <option value={contemplationWay.descricao.trim()} key={index}>
                                              {contemplationWay.descricao}
                                            </option>
                                          ))}
                                    </Form.Select>
                                    {/* <pre>{JSON.stringify(offer, null, 2)}</pre> */}
                                    <Form.Group
                                      hidden={
                                        offersInitial &&
                                        (offersInitial[index]?.lanceMaxEmbutido.trim() === '000' ||
                                          offersInitial[index]?.lanceEmbutidoLiberarConso === 'N')
                                      }
                                    >
                                      <Form.Check
                                        type={'checkbox'}
                                        label={`Lance embutido`}
                                        id={`embeddedBid-${index}`}
                                        checked={!!offersForm[index]?.embutido}
                                        disabled={false}
                                        onChange={(e) => {
                                          let selectedRule = contemplation?.find(
                                            (rule) =>
                                              rule.descricao === offer.selectedRule?.descricao &&
                                              rule.codigo === offer.lanceCodRegraApuracao
                                          );
                                          const _offers = [...offersForm];
                                          const lanceMaximoEmbutido = selectedRule
                                            ? Number(selectedRule.maxLanceEmbutido)
                                            : 0;
                                          const currentLanceOferta = parseFloat(
                                            _offers[index].lanceOferta.replace(',', '.') || '0'
                                          );

                                          // O limite efetivo é o menor entre maxLanceEmbutido e o lance ofertado
                                          const effectiveLimit = getLimiteEfetivoEmbutido(
                                            _offers[index].lanceTipoLance,
                                            lanceMaximoEmbutido,
                                            currentLanceOferta
                                          );

                                          let finalValue: string;

                                          switch (_offers[index].lanceTipoLance) {
                                            case '1':
                                              finalValue = effectiveLimit.toString();
                                              break;
                                            case '2':
                                              finalValue = effectiveLimit.toFixed(4);
                                              break;
                                            case '3':
                                              finalValue = effectiveLimit.toFixed(4);
                                              break;
                                            default:
                                              finalValue = effectiveLimit.toFixed(4);
                                              break;
                                          }

                                          const percEmbutido = e.target.checked ? finalValue : '';

                                          _offers[index] = {
                                            ..._offers[index],
                                            percEmbutido,
                                            embutido: e.target.checked,
                                          };

                                          setOffersForm(_offers);
                                        }}
                                      />
                                    </Form.Group>
                                  </Collumn>
                                  <Collumn>
                                    <InputGroup>
                                      <OfferInput
                                        type={lanceTypeLookupTable[offer.lanceTipoLance]}
                                        value={
                                          offer?.selectedRule?.forma === '15'
                                            ? offer.lanceQtdeMaximoGrupo
                                            : offer.lanceOferta
                                        }
                                        disabled={
                                          Number(offer.selectedRule?.maximo) === 0 ||
                                          (offer.selectedRule?.maximo === offer.selectedRule?.minimo &&
                                            offer.lanceTipoLance === (offersInitial ?? [])[index]?.lanceTipoLance) ||
                                          offer?.selectedRule?.forma === '15'
                                        }
                                        onValueChange={(val) => {
                                          const valDigitado = Number(val?.trim().replace(',', '.'));

                                          if (offer.lanceTipoLance === '3') {
                                            const maxGrupo =
                                              Number(offer.lanceValorMaximoGrupo.trim().replace(',', '.')) / 100;
                                            const minGrupo =
                                              Number(offer.lanceValorMinimoGrupo.trim().replace(',', '.')) / 100;

                                            if (!isNaN(maxGrupo) && !isNaN(minGrupo) && !isNaN(valDigitado)) {
                                              const invalido = valDigitado < minGrupo || valDigitado > maxGrupo;
                                              updateErrors(`lanceOferta${index}`, invalido);
                                            }
                                          } else {
                                            const maxGrupo = Number(
                                              offer.lanceQtdeMaximoGrupo.trim().replace(',', '.')
                                            );
                                            const minGrupo = Number(
                                              offer.lanceQtdeMinimoGrupo.trim().replace(',', '.')
                                            );

                                            if (!isNaN(maxGrupo) && !isNaN(minGrupo) && !isNaN(valDigitado)) {
                                              const invalido = valDigitado < minGrupo || valDigitado > maxGrupo;
                                              updateErrors(`lanceOferta${index}`, invalido);
                                            }
                                          }

                                          updatePercEmbutido(index, val);
                                        }}
                                      />
                                      <DropdownButton
                                        variant="outline-secondary"
                                        title={renderFilter(offer.lanceTipoLance)}
                                        id="input-group-dropdown-2"
                                        align="end"
                                        disabled={
                                          Number(offer.selectedRule?.maximo) === 0 ||
                                          (offer.selectedRule?.maximo === offer.selectedRule?.minimo &&
                                            offer.lanceTipoLance === (offersInitial ?? [])[index]?.lanceTipoLance) ||
                                          offer?.selectedRule?.forma === '15'
                                        }
                                      >
                                        {(offersInitial ?? [])[index].lanceTipoLance === '2' && (
                                          <Dropdown.Item
                                            onClick={() => {
                                              handleChangeTipoLance(index, '2');
                                            }}
                                          >
                                            %
                                          </Dropdown.Item>
                                        )}

                                        {(offersInitial ?? [])[index].lanceTipoLance === '1' && (
                                          <Dropdown.Item
                                            onClick={() => {
                                              handleChangeTipoLance(index, '1');
                                            }}
                                          >
                                            Parcelas
                                          </Dropdown.Item>
                                        )}
                                        {(offersInitial ?? [])[index].lanceOfertaEmValor === 'S' && (
                                          <Dropdown.Item
                                            onClick={() => {
                                              handleChangeTipoLance(index, '3');
                                            }}
                                          >
                                            R$
                                          </Dropdown.Item>
                                        )}
                                      </DropdownButton>
                                    </InputGroup>
                                    <div className="redText" hidden={!hasError(`lanceOferta${index}`)}>
                                      Oferta fora dos limites da modalidade
                                    </div>
                                    <Form.Group
                                      hidden={
                                        offersInitial &&
                                        (offersInitial[index]?.lanceMaxEmbutido.trim() === '000' ||
                                          offersInitial[index]?.lanceEmbutidoLiberarConso === 'N')
                                      }
                                    >
                                      <OfferInput
                                        type={
                                          lanceTypeLookupTable[
                                            offer.lanceTipoLance == '3'
                                              ? (offersInitial ?? [])[index].lanceTipoLance
                                              : offer.lanceTipoLance
                                          ]
                                        }
                                        value={offer.percEmbutido}
                                        disabled={!offersForm[index].embutido}
                                        onValueChange={(val) => {
                                          const parsedValue = val ? val.replace(',', '.') : '0';

                                          // Converta parsedValue para número usando parseFloat
                                          const validParsedNumber = parseFloat(parsedValue);
                                          var finalParsedValue = !isNaN(validParsedNumber) ? validParsedNumber : 0;

                                          // Limite máximo: menor valor entre maxLanceEmbutido e lanceOferta
                                          const maxLimit = Number(
                                            offersForm[index].selectedRule?.maxLanceEmbutido.trim().replace(',', '.') ??
                                              0
                                          );
                                          const lanceOfertaValue = Number(
                                            offersForm[index].lanceOferta.trim().replace(',', '.')
                                          );
                                          const effectiveMaxLimit = getLimiteEfetivoEmbutido(
                                            offersForm[index].lanceTipoLance,
                                            maxLimit,
                                            lanceOfertaValue
                                          );

                                          // Limita o valor digitado ao menor entre lance ofertado e max embutido
                                          const clampedValue = Math.min(finalParsedValue, effectiveMaxLimit);

                                          let percEmbutidoValue: string;

                                          switch (offersForm[index].lanceTipoLance) {
                                            case '1':
                                              percEmbutidoValue = clampedValue.toString();
                                              break;
                                            case '2':
                                              percEmbutidoValue = clampedValue.toFixed(4);
                                              break;
                                            case '3':
                                              percEmbutidoValue = clampedValue.toFixed(4);
                                              break;
                                            default:
                                              percEmbutidoValue = clampedValue.toFixed(4);
                                              break;
                                          }

                                          const _offers = [...offersForm];
                                          _offers[index] = {
                                            ..._offers[index],
                                            percEmbutido: percEmbutidoValue,
                                          };
                                          setOffersForm(_offers);

                                          const isAboveLimit =
                                            !Number.isNaN(finalParsedValue) && finalParsedValue > effectiveMaxLimit;

                                          // Atualiza os erros imediatamente antes de chamar setOffersForm se necessário
                                          updateErrors(`percEmbutido${index}`, isAboveLimit);
                                        }}
                                      />
                                    </Form.Group>
                                    <div className="redText" hidden={!hasError(`percEmbutido${index}`)}>
                                      Oferta acima do permitido
                                    </div>
                                    <div className={'grayText'}>
                                      Lance Livre Máximo:
                                      {offer.lanceValorMaximoGrupo &&
                                        formatMoney(Number(offer.lanceValorMaximoGrupo.trim().replace(',', '.')) / 100)}
                                      <br />
                                      Lance Livre Mínimo:
                                      {offer.lanceValorMinimoGrupo &&
                                        formatMoney(Number(offer.lanceValorMinimoGrupo.trim().replace(',', '.')) / 100)}
                                      <br />
                                      Lance Máximo:{' '}
                                      {offer.lanceTipoLance === '2' &&
                                      offer.selectedRule?.forma !== '11' &&
                                      offer.selectedRule?.forma !== '15'
                                        ? Number(offer.selectedRule?.maximo ?? 0)
                                        : Number(offer.lanceQtdeMaximoGrupo.trim().replace(',', '.'))}
                                      {unidade} <br />
                                      Lance Mínimo:{' '}
                                      {offer.lanceTipoLance === '2' &&
                                      offer.selectedRule?.forma !== '11' &&
                                      offer.selectedRule?.forma !== '15'
                                        ? Number(offer.selectedRule?.minimo ?? 0)
                                        : Number(offer.lanceQtdeMinimoGrupo.trim().replace(',', '.'))}
                                      {unidade} <br />
                                      {offersInitial &&
                                        !(
                                          offersInitial[index]?.lanceMaxEmbutido.trim() === '000' ||
                                          offersInitial[index]?.lanceEmbutidoLiberarConso === 'N'
                                        ) && (
                                          <>
                                            Lance Embutido Máximo:{' '}
                                            {Number(offer.selectedRule?.maxLanceEmbutido?.replace(',', '.') || 0)}
                                            {unidade}
                                          </>
                                        )}
                                    </div>
                                  </Collumn>
                                  <Collumn className="align-items-end align-items-md-center">
                                    <Trash
                                      size={24}
                                      className={'trashIcon'}
                                      onClick={() => {
                                        const _offers = [...offersForm];
                                        _offers[index] = {
                                          ..._offers[index],
                                          lanceOferta: '0',
                                          embutido: false,
                                        };
                                        /*
                                        _offers[index].selectedRule = contemplation?.find(
                                          (cont) => cont.forma === '99'
                                        );
                                        */

                                        setOffersForm(_offers);
                                      }}
                                    />
                                  </Collumn>
                                </InputLine>
                              </OfferForm>
                            );
                          })}
                        </div>
                      </div>
                    </div>
                  </Card.Body>
                </Accordion.Collapse>
              </Card>

              <Card>
                <CardHead className={formStep >= 2 ? 'finished' : formStep === 1 ? 'active' : ''}>
                  <Eye />
                  Revisão do Lance
                  {/*<CustomToggle eventKey='1'>Click me!</CustomToggle>*/}
                </CardHead>
                <Accordion.Collapse eventKey="1">
                  <div className={'w-100 d-flex flex-column gap-3'}>
                    {revisionOffers &&
                      revisionOffers.map((offer, index) => (
                        <Offer>
                          <Row>
                            <Collumn>
                              <div className={'mainData'}>
                                {offer.lanceGrupo} / {offer.lanceCota}{' '}
                              </div>
                              <Tag2>
                                {offersForm.find(
                                  (of) => of.lanceGrupo === offer.lanceGrupo && offer.lanceCota.includes(of.lanceCota)
                                )?.selectedRule?.forma === '11'
                                  ? 'Lance Livre'
                                  : 'Lance Limitado'}
                              </Tag2>
                              {offersForm.findIndex(
                                (of) =>
                                  of.embutido &&
                                  of.lanceGrupo === offer.lanceGrupo &&
                                  offer.lanceCota.includes(of.lanceCota)
                              ) > -1 && <Tag2>Lance Embutido</Tag2>}
                            </Collumn>
                            {/* <pre>{JSON.stringify(offer, null, 2)}</pre> */}
                            <Collumn>
                              <div className={'title'}>Oferta</div>
                              <div className={'data'}>
                                {offer.lanceOfertado.includes('Porcento') ? (
                                  <>{Number(offer.lanceOfertado.split('Porcento')[0].trim().replace(',', '.'))}%</>
                                ) : (
                                  <span className="mensagem-erro">{offer.lanceOfertado}</span>
                                )}
                              </div>
                            </Collumn>

                            <Collumn>
                              <div className={'title'}>
                                Valor Total do Lance <InfoCircleFill onClick={handleTooltip} />
                                <div ref={ref} className={'Valor do Lance a Pagar + Valor do Lance Embutido'}>
                                  <Overlay
                                    show={show}
                                    target={target}
                                    placement="top"
                                    container={ref}
                                    containerPadding={20}
                                  >
                                    <Popover id="popover-contained">
                                      <Popover.Body>Valor do Lance a Pagar + Valor do Lance Embutido</Popover.Body>
                                    </Popover>
                                  </Overlay>
                                </div>
                              </div>
                              <div className={'data'}>{formatMoney(offer.lanceValorTotal)}</div>
                            </Collumn>

                            <Collumn>
                              <div className={'title'}>Crédito</div>
                              <div className={'data'}>
                                {(() => {
                                  const parseCurrency = (value: string): number => {
                                    const parsedValue = parseFloat(value.replace(/\./g, '').replace(',', '.'));
                                    return isNaN(parsedValue) ? 0 : parsedValue;
                                  };

                                  const valorOriginal = offer['lanceVlrCredDisponivel'].trim();
                                  const creditoDisponivel = parseCurrency(valorOriginal);

                                  const valorEmbutidoStr = offer['lanceEmbutidoVlr'].trim();
                                  const valorEmbutido = parseCurrency(valorEmbutidoStr);

                                  const credito = creditoDisponivel + valorEmbutido;
                                  return isNaN(credito) ? '-' : formatMoney(credito);
                                })()}
                              </div>
                            </Collumn>
                            <Collumn>
                              <div className={'title'}>Crédito Disponível</div>
                              <div className={'data'}>
                                {formatMoney(offer['lanceVlrCredDisponivel'])
                                  ? formatMoney(offer['lanceVlrCredDisponivel'])
                                  : '-'}
                              </div>
                            </Collumn>
                          </Row>
                          <Row>
                            {offer.lanceEmbutidoVlr && offer.lanceEmbutidoVlr.trim() !== '' ? (
                              <>
                                <Collumn>
                                  <div className={'title'}>Oferta Embutido</div>
                                  <div className={'data'}>
                                    {`${Number(offer['lanceMsgTextoEmbutido'].trim().replace(',', '.'))} ${
                                      offer.lanceTipoLance === '1' ? 'Parcelas' : '%'
                                    }`}
                                  </div>
                                </Collumn>
                                <Collumn>
                                  <div className={'title'}>Valor Embutido</div>
                                  <div className={'data'}>{formatMoney(offer.lanceEmbutidoVlr)}</div>
                                </Collumn>
                              </>
                            ) : (
                              <>
                                <Collumn>
                                  <div className={'title'}></div>
                                  <div className={'data'}></div>
                                </Collumn>
                                <Collumn>
                                  <div className={'title'}></div>
                                  <div className={'data'}></div>
                                </Collumn>
                              </>
                            )}

                            <Collumn>
                              <div className={'title'}>Oferta em Espécie</div>
                              <div className={'data'}>
                                {(() => {
                                  const unidade = offer.lanceTipoLance === '1' ? ' Parcelas' : '%';

                                  const lanceOfertado = getNumericValue(offer.lanceOfertado);

                                  const percentualEmbutido = getNumericValue(offer['lanceMsgTextoEmbutido']);

                                  const percentualEmEspecie =
                                    lanceOfertado - (Number.isNaN(percentualEmbutido) ? 0 : percentualEmbutido);

                                  if (Number.isNaN(percentualEmEspecie)) return `-`;

                                  const finalPercentualEmEspecie =
                                    offer.lanceTipoLance === '1'
                                      ? String(percentualEmEspecie)
                                      : percentualEmEspecie.toFixed(0);

                                  return `${finalPercentualEmEspecie}${unidade}`;
                                })()}
                              </div>
                            </Collumn>
                            <Collumn>
                              <div className={'title'}>Valor em Espécie</div>
                              <div className={'data'}>{formatMoney(offer['lanceAPagarVlr'])}</div>
                            </Collumn>
                          </Row>
                          {/*<Collumn>*/}
                          {/*  <div className={'title'}>*/}
                          {/*    Valor do Lance Embutido <InfoCircleFill onClick={handleTooltip} />*/}
                          {/*    <div ref={ref} className={'Valor do Lance a Pagar + Valor do Lance Embutido'}>*/}
                          {/*      <Overlay*/}
                          {/*        show={show}*/}
                          {/*        target={target}*/}
                          {/*        placement="top"*/}
                          {/*        container={ref}*/}
                          {/*        containerPadding={20}*/}
                          {/*      >*/}
                          {/*        <Popover id="popover-contained">*/}
                          {/*          <Popover.Body>*/}
                          {/*            Valor do Lance Embutido a ser descontado do Valor do Crédito quando ocorrer a*/}
                          {/*            confirmação da Contemplação por lance*/}
                          {/*          </Popover.Body>*/}
                          {/*        </Popover>*/}
                          {/*      </Overlay>*/}
                          {/*    </div>*/}
                          {/*  </div>*/}
                          {/*  <div className={'data'}>R$ 0,00</div>*/}
                          {/*</Collumn>*/}
                        </Offer>
                      ))}

                    <div>
                      <div>
                        <Title2>
                          Valor Total dos Lances Ofertados
                          <InfoCircleFill onClick={handleTooltip} />
                          <div ref={ref} className={'Valor do Lance a Pagar + Valor do Lance Embutido'}>
                            <Overlay show={show} target={target} placement="top" container={ref} containerPadding={20}>
                              <Popover id="popover-contained">
                                <Popover.Body>
                                  Se selecionada a opção de Lance Embutido, o valor do Embutido e o valor do Lance em
                                  Espécie devem ser confirmados com a Administradora no momento do pagamento do lance.
                                </Popover.Body>
                              </Popover>
                            </Overlay>
                          </div>
                          <h2>
                            {formatMoney(
                              revisionOffers.reduce(
                                (acc, cur) => Number(cur.lanceValorTotal.replace(/\./g, '').replace(',', '.')) + acc,
                                0
                              )
                            )}
                          </h2>
                        </Title2>
                        <div className={'d-flex gap-3 '}>
                          <CustomToggle eventKey={'0'} onClick={() => setFormStep(0)} hierarchy={'secondary'}>
                            Voltar
                          </CustomToggle>
                          <CustomToggle eventKey={'2'} onClick={() => handleSave()}>
                            Salvar
                          </CustomToggle>
                        </div>
                      </div>
                    </div>
                  </div>
                </Accordion.Collapse>
              </Card>

              <Card>
                <CardHead className={formStep >= 3 ? 'finished' : formStep === 2 ? 'active' : ''}>
                  Confirmação do Lance
                  {/*<CustomToggle eventKey='0'>Click me!</CustomToggle>*/}
                </CardHead>
                <Accordion.Collapse eventKey="2">
                  <Card.Body ref={printRef}>
                    <div className={'w-100 d-flex flex-column gap-3'}>
                      {finalOffers.map((offer, index) => (
                        <Offer>
                          <Row>
                            <Collumn>
                              <div className={'mainData'}>
                                {offer.lanceGrupo} / {offer.lanceCota}{' '}
                              </div>
                              <Tag2>
                                {offersForm.find(
                                  (of) => of.lanceGrupo === offer.lanceGrupo && offer.lanceCota.includes(of.lanceCota)
                                )?.selectedRule?.forma === '11'
                                  ? 'Lance Livre'
                                  : 'Lance Limitado'}
                              </Tag2>
                              {offersForm.findIndex(
                                (of) =>
                                  of.embutido &&
                                  of.lanceGrupo === offer.lanceGrupo &&
                                  offer.lanceCota.includes(of.lanceCota)
                              ) > -1 && <Tag2>Lance Embutido</Tag2>}
                            </Collumn>
                            {/* <pre>{JSON.stringify(offer, null, 2)}</pre> */}
                            <Collumn>
                              <div className={'title'}>Data Assembleia</div>
                              <div className={'data'}>{offer.lanceDataAssembleia}</div>
                            </Collumn>

                            <Collumn>
                              <div className={'title'}>Oferta</div>
                              <div className={'data'}>{offer.lanceOfertado.replace('Porcento', ' %')}</div>
                            </Collumn>
                            <Collumn>
                              <div className={'title'}>Valor Total do Lance</div>
                              <div className={'data'}>
                                {' '}
                                {formatMoney(Number(offer.lanceValorTotal.replace(/\./g, '').replace(',', '.')))}
                              </div>
                            </Collumn>
                            <Collumn>
                              {offer.lanceOfertado === 'Cancelada ' ? (
                                <></>
                              ) : (
                                <>
                                  <div className={'title'}>Senha para consulta</div>
                                  <div className={'data'}>{offer.senha}</div>
                                </>
                              )}
                            </Collumn>
                          </Row>
                          <Row>
                            {offer.lanceEmbutidoVlr && offer.lanceEmbutidoVlr.trim() !== '' ? (
                              <>
                                <Collumn>
                                  <div className={'title'}>Oferta Embutido </div>
                                  <div className={'data'}>
                                    {(() => {
                                      const embutido = Number(percEmbutido[index]?.trim().replace(',', '.') || 0);

                                      const unidade = offer.lanceOfertado?.includes('Parcelas') ? 'Parcelas' : '%';

                                      const valorFormatado =
                                        unidade === 'Parcelas' ? embutido.toString() : embutido.toFixed(4);

                                      return `${valorFormatado} ${unidade}`;
                                    })()}
                                  </div>
                                </Collumn>

                                <Collumn>
                                  <div className={'title'}>Valor Embutido </div>
                                  <div className={'data'}>{formatMoney(offer.lanceEmbutidoVlr)}</div>
                                </Collumn>
                              </>
                            ) : (
                              <>
                                <Collumn>
                                  <div className={'title'}></div>
                                  <div className={'data'}></div>
                                </Collumn>
                                <Collumn>
                                  <div className={'title'}></div>
                                  <div className={'data'}></div>
                                </Collumn>
                              </>
                            )}
                            <Collumn>
                              <div className={'title'}>Oferta em Espécie </div>
                              <div className={'data'}>
                                {(() => {
                                  const isParcelas = hasParcelas(offer.lanceOfertado);

                                  const unidade = isParcelas ? 'Parcelas' : '%';

                                  const lance = getNumericValue(offer.lanceOfertado);

                                  const embutido = getNumericValue(percEmbutido[index] ?? '0');

                                  const resultado = lance - (Number.isNaN(embutido) ? 0 : embutido);

                                  if (Number.isNaN(resultado)) return `0`;

                                  const valorFormatado = isParcelas ? String(resultado) : resultado.toFixed(4);
                                  return `${valorFormatado} ${unidade}`;
                                })()}
                              </div>
                            </Collumn>

                            <Collumn>
                              <div className={'title'}>Valor em Espécie </div>
                              <div className={'data'}>{formatMoney(offer['lanceAPagarVlr'])}</div>
                            </Collumn>

                            <Collumn>
                              <div className={'title'}>Crédito</div>
                              <div className={'data'}>
                                {(() => {
                                  const parseCurrency = (value: string): number => {
                                    const parsedValue = parseFloat(value.replace(/\./g, '').replace(',', '.'));
                                    return isNaN(parsedValue) ? 0 : parsedValue;
                                  };

                                  const valorOriginal = offer['lanceVlrCredDisponivel'].trim();
                                  const creditoDisponivel = parseCurrency(valorOriginal);

                                  const valorEmbutidoStr = offer['lanceEmbutidoVlr'].trim();
                                  const valorEmbutido = parseCurrency(valorEmbutidoStr);

                                  const credito = creditoDisponivel + valorEmbutido;
                                  return isNaN(credito) ? '-' : formatMoney(credito);
                                })()}
                              </div>
                            </Collumn>
                            <Collumn>
                              <div className={'title'}>Crédito Disponível</div>
                              <div className={'data'}>
                                {formatMoney(offer['lanceVlrCredDisponivel'])
                                  ? formatMoney(offer['lanceVlrCredDisponivel'])
                                  : '-'}
                              </div>
                            </Collumn>
                          </Row>
                        </Offer>
                      ))}

                      {process.env.REACT_APP_SEGMENTO === 'CNK' && (
                        <div
                          style={{
                            textAlign: 'center',
                            color: '#ff0b07',
                            background: '#ffc',
                            border: '1px solid #ffecb4',
                            borderRadius: '4px',
                            padding: '8px 16px',
                            fontSize: '0.85rem',
                            fontWeight: 'bold',
                          }}
                        >
                          Em casos de lance carta avaliação, direcionar para{' '}
                          <a href="mailto:lance@kasinskiconsorcio.com.br">lance@kasinskiconsorcio.com.br</a>
                          , juntamente com o laudo de avaliação e documento do veículo em nome do titular.
                          <br />
                          <br />
                          Caso os documentos não sejam direcionados para o e-mail acima até um dia útil antes da
                          assembleia, a oferta de lance não será realizada.
                        </div>
                      )}
                      <div>
                        {finalOffers.some((offer) => offer.pdfPath) && (
                          <Button
                            onClick={() => {
                              const firstPdfPath = finalOffers.find((offer) => offer.pdfPath)?.pdfPath;
                              if (firstPdfPath) {
                                window.open(firstPdfPath, '_blank', 'noopener,noreferrer');
                              }
                            }}
                          >
                            <Printer /> Imprimir
                          </Button>
                        )}
                      </div>
                    </div>
                  </Card.Body>
                </Accordion.Collapse>
              </Card>
            </Accordion>
          </Forms>
        ) : (
          <div className={'d-flex flex-column gap-3'}>
            {offersInitial &&
              offersInitial
                .filter((offer) => Number(offer.lanceOferta) !== 0)
                .map((offer) => (
                  <Offer>
                    <div className={'d-flex flex-column'}>
                      <div className={'title'}>Grupo/ Quota</div>
                      <div className={'mainData'}>
                        {offer.lanceGrupo} / {offer.lanceCota}
                      </div>
                    </div>

                    <div className="d-flex gap-4 justify-content-between flex-wrap">
                      <div className={'d-flex flex-column'}>
                        <div className={'title'}>Data Assembleia</div>
                        <div className={'data'}>{offer.lanceDataAssembleia}</div>
                      </div>

                      <div className={'d-flex flex-column'}>
                        <div className={'title'}>Oferta</div>
                        <div className={'data'}>
                          {Number(offer.lanceOferta.trim().replace(',', '.'))}
                          {offer.lanceTipoLance === '1' ? ' Parcelas' : ' %'}
                        </div>
                      </div>
                    </div>
                  </Offer>
                ))}
          </div>
        )}
      </>
    );
  };

  return <>{userData && <div>{pageContent()}</div>}</>;
};

export default BidOffer;
